export function installUpgradeModalFetchInterceptor() {
  if (window.__upgradeFetchInterceptorInstalled) return
  window.__upgradeFetchInterceptorInstalled = true

  const nativeFetch = window.fetch
  window.fetch = async (...args) => {
    const res = await nativeFetch(...args)
    try {
      if (res && res.status === 400) {
        // Clone and parse JSON safely
        const clone = res.clone()
        let data = null
        try { data = await clone.json() } catch (_) {}
        const msg = String(data?.message || '')
        const action = String(data?.action || '')
        if (/max limit/i.test(msg) && /upgrade/i.test(action)) {
          if (typeof window.__openPlanUpgradeModal === 'function') {
            window.__openPlanUpgradeModal()
          }
        }
      }
    } catch (_) {}
    return res
  }
} 